export const parseEnumToSelectValues = (enumValue) => {
    const listValues = Object.values(enumValue)
    return ["", ...listValues]
}

export const parseArrayToSelectValues = (array) => {
    return ["", ...array]
}